var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerbilogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03765 17.5L8.03765 14.0183M8.03765 17.5L8.03857 14.067C8.03857 14.0507 8.03826 14.0345 8.03765 14.0183M8.03765 17.5L4.8 17.5C4.35817 17.5 4 17.0523 4 16.5L4 14.0667C4 13.5144 4.35818 13.0667 4.8 13.0667L7.23857 13.0667C7.66744 13.0667 8.01748 13.4885 8.03765 14.0183M8.03765 17.5L12.0765 17.5M8.03765 14.0183L8.03765 9.35333C8.03765 8.80105 8.39582 8.35333 8.83765 8.35333L11.2765 8.35333C11.7183 8.35333 12.0765 8.80105 12.0765 9.35333M12.0765 17.5L12.0765 9.35333M12.0765 17.5L15.2 17.5C15.6418 17.5 16 17.0523 16 16.5L16 3.5C16 2.94772 15.6418 2.5 15.2 2.5L12.8765 2.5C12.4347 2.5 12.0765 2.94772 12.0765 3.5L12.0765 9.35333M2 17.5L18 17.5",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbilogo);
export default __webpack_public_path__ + "static/media/powerbilogo.7e91fce4eac8d16301f2861c62772afa.svg";
export { ForwardRef as ReactComponent };